export default "__VITE_ASSET__CUFlVK4w__"